import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Grid, Typography, Button, Hidden } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DisableableTooltip from 'components/DisableableTooltip'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));

const TableEditBar = props => {
  const {
    selected,
    className,
    onDelete,
    onUpdate,
    ...rest
  } = props;

  const classes = useStyles();
  const open = selected.length > 0;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      // eslint-disable-next-line react/jsx-sort-props
      PaperProps={{ elevation: 1 }}
      variant="persistent"
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Grid
          alignItems="center"
          container
          justifyContent='space-between'
          spacing={2}
        >
          <Hidden smDown>
            <Grid
              item
            >
              <Typography
                color="textSecondary"
                variant="subtitle1"
              >
                {selected.length} selected
              </Typography>
            </Grid>
          </Hidden>
          <Grid
            item
          >
            <div className={classes.actions}>
              <Button onClick={onDelete}>
                <DeleteIcon className={classes.buttonIcon} />
                Delete Selected Dataset{selected.length > 1 ? 's':''}
              </Button>
              <DisableableTooltip
                disabled={selected.length === 1}
                title='You may only update the details of one dataset at a time'
              >
                <Button 
                  disabled={selected.length !== 1} 
                  onClick={onUpdate}
                >
                  <EditIcon className={classes.buttonIcon} />
                  Update Dataset Details
                </Button>
              </DisableableTooltip>
            </div>
          </Grid>
          <Grid item/>
        </Grid>
      </div>
    </Drawer>
  );
};

TableEditBar.propTypes = {
  className: PropTypes.string,
  datasets: PropTypes.array.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onUpdate: PropTypes.func,
  selected: PropTypes.array.isRequired
};

export default TableEditBar;
